import React from 'react';
import posed from 'react-pose';
import { Flex } from 'rebass';
import { useMediaQuery } from 'react-responsive';
import theme from "../../gatsby-plugin-theme-ui";

const Blurred = posed(Flex)({
	blurred: {
		filter: 'blur(3px)',
	},
	semiTransparent: {
		filter: 'blur(1px)',
	},
	transparent: {
		filter: 'blur(0px)',
	}
});

const BlurredText = ({ children, active, past, ...rest }) => {
	const isTabletOrMobile = useMediaQuery({ maxWidth: theme.breakpoints[1] });
	return (
		<Blurred
			pose={(active|| isTabletOrMobile) ? 'transparent' : past ? 'semiTransparent' : 'blurred'}
			{...rest}
		>
			{children}
		</Blurred>
	);
};

export default BlurredText;
